import { InfoCard } from "../../shared/InfoCard";
import translationKeys from "../../../../contexts/I18nContext/translationKeys";
import { Translate } from "../../../Translation/Translate";
import { WhmStack, WhmTooltip } from "@securitize/reactjs-whm";
import { useDownloadInfoMutation } from "../../../../data/useProfile";
import React, { useContext } from "react";
import { SnackbarContext } from "../../../shared/Snackbar";
import ErrorSnackbar from "../../../shared/ErrorSnackbar";
import {
  ProfilePermissionType,
  ProfilePermissionTypes,
} from "../../../../data/dtos/profile-config.dto";
import { CustomWhmLoadingButton } from "../../../shared/CustomWhmLoadingButton";

interface SettingsDownloadInfoProps {
  permission: ProfilePermissionType;
}

export default function SettingsDownloadInfoCard({
  permission,
}: SettingsDownloadInfoProps) {
  const isReadOnly = permission === ProfilePermissionTypes.READ_ONLY;
  const downloadInfoMutation = useDownloadInfoMutation();
  const { showSnackbar } = useContext(SnackbarContext);

  const requestDownloadData = () =>
    downloadInfoMutation.mutate(void 0, {
      onSuccess: () => {
        showSnackbar({
          severity: "info",
          message: (
            <Translate
              translationKey={
                translationKeys.DOWNLOAD_DATA_SECURITY_CARD_SUCCESS
              }
            />
          ),
        });
      },
      onError: (error) => {
        showSnackbar({
          severity: "error",
          message: <ErrorSnackbar error={error} />,
        });
      },
    });

  return (
    <InfoCard
      title={
        <Translate
          translationKey={translationKeys.DOWNLOAD_DATA_SECURITY_CARD_TITLE}
        />
      }
      subtitle={
        <Translate
          translationKey={translationKeys.DOWNLOAD_DATA_SECURITY_CARD_SUBTITLE}
        />
      }
      action={
        isReadOnly ? (
          <WhmTooltip
            title={
              <Translate
                translationKey={
                  translationKeys.DOWNLOAD_DATA_SECURITY_CARD_TOOLTIP
                }
              />
            }
            placement="top-start"
            data-test-id="profile-settings-download-information-disabled-tooltip"
            sx={{ minWidth: "fit-content" }}
          >
            <WhmStack>
              <CustomWhmLoadingButton
                loading={downloadInfoMutation.isPending}
                variant="outlined"
                onClick={requestDownloadData}
                disabled={isReadOnly}
              >
                <Translate
                  translationKey={
                    translationKeys.DOWNLOAD_DATA_SECURITY_CARD_CTA
                  }
                />
              </CustomWhmLoadingButton>
            </WhmStack>
          </WhmTooltip>
        ) : (
          <CustomWhmLoadingButton
            loading={downloadInfoMutation.isPending}
            variant="outlined"
            onClick={requestDownloadData}
            disabled={isReadOnly}
          >
            <Translate
              translationKey={translationKeys.DOWNLOAD_DATA_SECURITY_CARD_CTA}
            />
          </CustomWhmLoadingButton>
        )
      }
      smallPadding
    />
  );
}
